import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import { fsGetThemePref, fsSaveThemePref } from '../services/firestoreDb';

const ThemeContext = createContext(null);
const STORAGE_KEY = 'sm_theme';

export const THEMES = [
  { id: 'ocean',  label: 'Ocean',  colors: ['#059669', '#0d9488'] },
  { id: 'sunset', label: 'Sunset', colors: ['#ea580c', '#db2777'] },
  { id: 'forest', label: 'Forest', colors: ['#15803d', '#65a30d'] },
  { id: 'grape',  label: 'Grape',  colors: ['#7c3aed', '#a21caf'] },
];

function isValidTheme(id) {
  return THEMES.some((t) => t.id === id);
}

export function ThemeProvider({ children }) {
  const { user } = useAuth();
  const uid = user?.id;
  const [theme, setThemeState] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return isValidTheme(stored) ? stored : 'ocean';
  });

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
  }, [theme]);

  useEffect(() => {
    if (!uid) return;
    fsGetThemePref(uid)
      .then((remote) => {
        if (remote && isValidTheme(remote)) {
          setThemeState(remote);
          localStorage.setItem(STORAGE_KEY, remote);
        }
      })
      .catch(() => {});
  }, [uid]);

  const setTheme = (id) => {
    if (!isValidTheme(id)) return;
    setThemeState(id);
    localStorage.setItem(STORAGE_KEY, id);
    if (uid) fsSaveThemePref(uid, id).catch(() => {});
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes: THEMES }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
